var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('vs-wrapper',{attrs:{"space":"small"}},[_c('vs-autocomplete',{attrs:{"data-test":"resource-assignment","label":"Assign To","items":_setup.assignmentOptions,"value":_setup.assignmentValue},on:{"input":_setup.updateAssignment}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }